export const DivLupaPesquisarCond = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    borderBottom: '1px solid white',
    height: '30px'
}

export const InputPesquisaCond = {
    // border: '1px solid red',
    width: '300px',
    display: 'none',
    position: 'absolute',
    right: 0,
    height: '30px'
}

export const BoxVerdePesquisa = {
    width: '100%',
    height: '100%',
    backgroundColor: '#2e7d32',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid white',
    borderLeft: '1px solid white',
    borderRight: '1px solid white',
    '&:hover': { backgroundColor: '#1b5e20' }
}

export const BoxPesquisaAlinhamento = {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
}

export const BoxPesquisaIconSerach = {
    fontSize: '17px',
    marginRight: '2px'
}
